// services/business-entity.service.ts
import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

import { BusinessSearchCommand } from '../../models/business-search';
import { Business } from '../../models/finance/business';
import { ApiResponse, PaginatedApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class BusinessProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.financeApi + '/api/v1/business';

  public getById(id: string): Observable<ApiResponse<Business>> {
    return this.httpClient.get<ApiResponse<Business>>(`${this.baseUrl}/${id}`);
  }

  public getAll(): Observable<ApiResponse<Business[]>> {
    return this.httpClient.get<ApiResponse<Business[]>>(`${this.baseUrl}/all`);
  }

  public search(
    searchCommand: BusinessSearchCommand,
    matchAny = false,
    pageNumber = 1,
    pageSize = 25,
  ): Observable<ApiResponse<PaginatedApiResponse<Business>>> {
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<Business>>>(
      `${this.baseUrl}/search?matchAny=${matchAny}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
      searchCommand,
    );
  }

  public getByIds(ids: string[]): Observable<ApiResponse<Business[]>> {
    return this.httpClient.post<ApiResponse<Business[]>>(this.baseUrl + '/batch/ids', ids);
  }

  /**
   * The Business the current site (X-Site-Id) operates under, or null when the site has none configured (#5969).
   * Finance resolves it, so every UI agrees on who "we" are for a site.
   */
  public getSiteBusiness(): Observable<ApiResponse<Business | null>> {
    return this.httpClient.get<ApiResponse<Business | null>>(environment.proxyUrls.financeApi + '/api/v1/tax-authorization/site-business');
  }
}
